import { WorkOrderTableRow } from "./WorkOrderTableRow";

export default WorkOrderTableRow;
